// 38×22 pill switch with an animated knob and a primary track when on. Exported
// so other surfaces that render a bare MUI <Switch> (e.g. the Notification
// Delivery card) can match this look without duplicating the rules.
export const pillSwitchStyle = theme => ({
    width: 38,
    height: 22,
    padding: 0,
    display: 'flex',
    '& .MuiSwitch-switchBase': {
        padding: 2,
        transition: theme.transitions.create(['transform'], { duration: 200 }),
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: theme.palette.common.white,
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: theme.palette.primary.main,
            },
        },
        // MUI fades the whole switch to ~12% opacity when disabled, which makes
        // it nearly invisible. Instead keep a solid, clearly-readable pill: a
        // white knob on a light-grey track (a shade lighter than the enabled
        // off-state so it still reads as non-interactive), and a muted primary
        // track for the rarer disabled-on case.
        '&.Mui-disabled': {
            '& .MuiSwitch-thumb': {
                color: theme.palette.common.white,
            },
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: theme.palette.grey[300],
            },
            '&.Mui-checked + .MuiSwitch-track': {
                opacity: 0.6,
                backgroundColor: theme.palette.primary.main,
            },
        },
    },
    '& .MuiSwitch-thumb': {
        width: 18,
        height: 18,
        boxShadow: 'none',
    },
    '& .MuiSwitch-track': {
        borderRadius: 11,
        opacity: 1,
        backgroundColor: theme.palette.grey[400],
    },
});

export default theme => ({
    // Applied to the FormControlLabel (the switch + its text). MUI defaults the
    // root to marginLeft: -11px (to align a lone control with body text); in the
    // compact card rows that negative margin pushes the switch outward so it
    // overlaps the card's border when highlighted. Reset it and use a flex gap
    // so the label text sits clear of the track.
    label: {
        marginLeft: 0,
        gap: theme.spacing(1.5),
        '& .MuiFormControlLabel-label': {
            fontWeight: 600,
        },
    },
    error: {
        color: theme.palette.error.main,
    },
    switch: pillSwitchStyle(theme),
});
